import { render, staticRenderFns } from "./CrmReasons.vue?vue&type=template&id=8a7ee282&scoped=true&"
import script from "./CrmReasons.vue?vue&type=script&lang=js&"
export * from "./CrmReasons.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8a7ee282",
  null
  
)

export default component.exports